import React from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import classNames from "classnames";
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";
import s from "./styles.scss";
import { modalFrameDismissProps } from "./modalFrameDismiss";

interface Props {
  title: string;
  subtitle?: string;
  titleClassName?: string;
  contentClassName?: string;
  isOpen: boolean;
  toggle: () => void;
  size?: string;
  centered?: boolean;
  dismissible?: boolean;
  children?: React.ReactNode;
}

class ModalFrame extends React.Component<Props, void> {
  render() {
    const {
      size,
      title,
      subtitle,
      titleClassName,
      contentClassName,
      centered,
      toggle,
      dismissible,
      children,
      ...config
    } = this.props;
    const dismiss = modalFrameDismissProps(dismissible !== false);
    const headerToggle = dismiss.showClose ? toggle : undefined;

    return (
      <Modal
        size={size || "md"}
        centered={centered}
        {...config}
        toggle={headerToggle}
        backdrop={dismiss.backdrop}
        keyboard={dismiss.keyboard}
        contentClassName={classNames(s.modalBorder, contentClassName)}
      >
        {title && (
          <ModalHeader className={s.modalHeader} toggle={headerToggle}>
            {title && (
              <Row>
                <Col xs={subtitle ? 6 : 12}>
                  <span className={titleClassName}>{title}</span>
                </Col>
                {subtitle && (
                  <Col className={s.label} xs={6}>
                    {subtitle}
                  </Col>
                )}
              </Row>
            )}
          </ModalHeader>
        )}
        <ModalBody className={s.modalPadding}>{children}</ModalBody>
      </Modal>
    );
  }
}

export default withStyles(s)(ModalFrame);
